<div fxLayout="column" fxLayoutAlign="end end" class="w-100">
	<button
		mat-button
		id="editFundraiserImageButton"
		(click)="openImageCropperDialog()"
	>
		<mat-icon>edit</mat-icon>
		<span i18n="@@button_editImage_Video" color="accent">
			Edit Image/Video
		</span>
	</button>

	<!-- <div *ngIf="this.videoPath" [innerHTML]="youtubeIframe" fxLayout="column" fxLayoutAlign="end end"
		class="w-100 aspect-ratio" fxFlex="100"></div> -->
	<div
		class="w-100 aspect-ratio"
		*ngIf="this.videoPath"
		[innerHTML]="youtubeIframe"
	></div>

	<img
        class="fundraiser-image"
		width="100%"
		*ngIf="!this.videoPath"
		id="fundraiser_page_image"
		[src]="this.imagePath"
		(error)="fallbackToDefaultImage()"
	/>
</div>
